import {
  GAME_ID,
  ALEX_SPEAK,
  ALEX_SILENT,
  ALEX_SILENT_STATE,
  ALEX_SPEAK_STATE,
} from '../foodTruckConstants';

const initialState = { alexState: ALEX_SILENT_STATE };

const foodTruckAlexReducer = (state = initialState, action) => {
  if (action.gameId !== GAME_ID) {
    return state;
  }

  switch (action.type) {
    case ALEX_SILENT: {
      return { alexState: ALEX_SILENT_STATE };
    }
    case ALEX_SPEAK: {
      return { alexState: ALEX_SPEAK_STATE };
    }
    default:
      return state;
  }
};

export default foodTruckAlexReducer;
